import { getKeys } from './getKeys'

export const referralTranslations = {
  // Page Header
  REFERRAL_RECORDS: 'Referral Records',
  ADD_REFERRAL: 'Add Referral',

  // Modal
  REFERRAL_RECORD: 'Referral record',
  CREATE_REFERRAL: 'Create Referral',
  EDIT_REFERRAL: 'Edit Referral',
  SUBJECT_OF_CARE: 'Subject of Care',
  SUBJECT_OF_CARE_REQUIRED: 'Subject of Care is required',
  REASON_FOR_REFERRAL: 'Reason for Referral',
  REASON_FOR_REFERRAL_REQUIRED: 'Reason for Referral is required',
  REASON_FOR_REFERRAL_MAX_LENGTH: 'Reason for Referral must not exceed 5000 characters',
  REASON_FOR_REFERRAL_PLACEHOLDER: 'Enter reason for referral',
  REFERRED_TO: 'Referred To',
  REFERRED_TO_REQUIRED: 'Referred To is required',
  REFERRED_TO_MAX_LENGTH: 'Referred To must not exceed 500 characters',
  REFERRED_TO_PLACEHOLDER: 'Enter who the resident is being referred to',
  REFERRAL_DATE: 'Referral Date',
  REFERRAL_DATE_REQUIRED: 'Referral Date is required',
  REFERRAL_DATE_PLACEHOLDER: 'Select referral date',
  ATTACHMENTS: 'Attachments (Optional)',
  ATTACHMENTS_MAX: 'Maximum 3 attachments allowed',
  ADD_DOCUMENT: 'Add Document',
  REMOVE: 'Remove',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  SAVE_REFERRAL: 'Save Referral',
  ADD: 'Add',

  // List
  NO_REFERRALS_FOUND: 'No referrals found',
  NO_REFERRALS_DESCRIPTION: 'There are no referrals recorded for this resident yet.',
  ARCHIVED_REFERRALS: 'Archived Referrals',
  NO_DATE_SPECIFIED: 'No date specified',

  // Actions
  VIEW: 'View',
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVED: 'Archived',
  ACTIVE: 'Active',
  UN_ARCHIVE: 'Un-archive',
  RESTORE: 'Restore',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  CREATED_BY: 'Created by',
  UPDATED_BY: 'Updated by',
  ARCHIVED_BY: 'Archived by',

  // Archive Modal
  ARCHIVE_REFERRAL: 'Archive Referral',
  RESTORE_REFERRAL: 'Restore Referral',
  ARCHIVE_CONFIRMATION: 'Are you sure you want to archive this referral? Archived referrals can be restored later.',
  RESTORE_CONFIRMATION: 'Are you sure you want to restore this referral to active status?',

  // Character Counters
  CHARACTERS_REMAINING: '{{count}}/{{max}} characters',

  // Success Messages
  REFERRAL_CREATED: 'Referral created successfully',
  REFERRAL_UPDATED: 'Referral updated successfully',
  REFERRAL_ARCHIVED: 'Referral archived successfully',
  REFERRAL_RESTORED: 'Referral restored successfully',

  // Error Messages
  FAILED_TO_CREATE: 'Failed to create referral',
  FAILED_TO_UPDATE: 'Failed to update referral',
  FAILED_TO_ARCHIVE: 'Failed to archive referral',
  FAILED_TO_RESTORE: 'Failed to restore referral',
  PERMISSION_DENIED: "You don't have permission to perform this action",
  REFERRAL_NOT_FOUND: 'Referral not found or has been deleted',
  SOMETHING_WENT_WRONG: 'Something went wrong. Please try again.'
}

export const referralConstants = getKeys(referralTranslations)
